<template>
  <div class="index">
    <div class="content-left">
      <div class="titlelogo">
        <img src="@/assets/logo_khy.png" alt="" />
        <h3>医疗机构在线考核云平台</h3>
      </div>

      <div class="navbtn">
        <div
          class="navbtn-content"
          :class="{ isAcitve: show, passActive: noshow }"
        >
          <h1>
            <b v-if="!noshow">1</b>
          </h1>
          <span>输入账号</span>
        </div>
        <div
          class="navbtn-content"
          :class="{ isAcitve: show1, passActive: noshow1 }"
        >
          <h1>
            <b v-if="!noshow1">2</b>
          </h1>
          <span>验证身份</span>
        </div>
        <div
          class="navbtn-content"
          :class="{ isAcitve: show2, passActive: noshow2 }"
        >
          <h1>
            <b v-if="!noshow2">3</b>
          </h1>
          <span>设置新密码</span>
        </div>
        <div
          class="navbtn-content"
          :class="{ isAcitve: show3, passActive: noshow3 }"
        >
          <h1>
            <b v-if="!noshow3">4</b>
          </h1>
          <span>完成</span>
        </div>
      </div>

      <div class="forget_content">
        <keep-alive>
          <component :is="coms" :cutcom="cutcom" @sendguid='getguid' @sendguida="sendguida"></component>
        </keep-alive>
      </div>
      <div class="foot">
        Copyright 2005-2018 英腾教育科技股份有限公司 备案信息：桂ICP备09009842号
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isActive: 1,
      guidcode:'',
      guid:'',  //传过来的guid,
      phone:''
    };
  },
  components: {
    CheckedStatus: () => import("./components/checkedStatus"),
    ForgetFinish: () => import("./components/forgetFinish"),
    ForgetAccount: () => import("./components/forgetAccount"),
    SetNewPassWord: () => import("./components/setNewPassWord"),
  },
  methods: {
    cutcom(index) {
      this.isActive = index;
      if (index === 1) {
        if (this.userName === '' || this.VerifyCode === '') {
          this.$message.success('请完善信息')
          return
        }
      } else if (index === 2) {
        
      } else if (index === 3) {
        
      }
    },
    getguid(a){
      this.guidcode = a;
      console.log(this.guidcode);
    },
    sendguida(b,c){
       this.guid = b;
       this.phone = c;
      console.log(this.guid);
    }
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "ForgetAccount";
        case 1:
          return "CheckedStatus";
        case 2:
          return "SetNewPassWord";
        case 3:
          return "ForgetFinish";
      }
      return "ss";
    },
    show() {
      let a = true;
      if (this.isActive === 0) {
        a = true;
      } else {
        a = false;
      }
      return a;
    },
    noshow() {
      let a = true;
      if (this.isActive > 0) {
        a = true;
      } else {
        a = false;
      }
      return a;
    },
    show1() {
      let a = true;
      if (this.isActive === 1) {
        a = true;
      } else {
        a = false;
      }
      return a;
    },
    noshow1() {
      let a = true;
      if (this.isActive > 1) {
        a = true;
      } else {
        a = false;
      }
      return a;
    },
    show2() {
      let a = true;
      if (this.isActive === 2) {
        a = true;
      } else {
        a = false;
      }
      return a;
    },
    noshow2() {
      let a = true;
      if (this.isActive > 2) {
        a = true;
      } else {
        a = false;
      }
      return a;
    },
    show3() {
      let a = true;
      if (this.isActive === 3) {
        a = true;
      } else {
        a = false;
      }
      return a;
    },
    noshow3() {
      let a = true;
      if (this.isActive > 3) {
        a = true;
      } else {
        a = false;
      }
      return a;
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  .content-left {
    flex-grow: 1;
    height: 100%;
    background-color: rgb(255, 255, 255);
    .titlelogo {
      margin-top: 20px;
      height: 100px;
      margin-left: 40px;
      display: flex;
      color: rgb(67, 66, 170);
      align-items: center;
      img {
        width: 100px;
        height: 100px;
      }
      h3 {
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: bold;
        line-height: 56px;
        color: #333333;
        margin-left: 30px;
      }
    }
  }
}
.navbtn {
  width: 1500px;
  height: 53px;
  margin: 50px auto;
  display: flex;
  .navbtn-content {
    display: flex;
    align-items: center;
    color: rgba(0, 0, 0, 0.14901960784313725);
    &:nth-child(n + 2) {
      &::before {
        content: "";
        width: 200px;
        height: 2px;
        background: #e9e9e9;
        margin-left: 30px;
        margin-right: 30px;
      }
    }
    h1 {
      font-size: 22px;
      width: 53px;
      height: 53px;
      border-radius: 50%;
      text-align: center;
      line-height: 53px;
      font-weight: 400;
      border: 1px solid rgba(0, 0, 0, 0.14901960784313725);
    }
    span {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      text-align: center;
      vertical-align: middle;
      margin-left: 14px;
    }
  }
}
.forget_content {
  width: 900px;
  height: 400px;
  background: rgba(236, 246, 255, 0.5);
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.isAcitve {
  span {
    color: #333333;
  }
  h1 {
    color: rgb(255, 255, 255);
    background-color: #1890ff;
    border: none !important;
  }
  &:nth-child(n + 2) {
    &::before {
      background: #1890ff !important;
    }
  }
}
.passActive {
  span {
    color: #333333;
  }
  h1 {
    background-image: url(../../assets/finish.png) !important;
    border: none !important;
  }
  &:nth-child(n + 2) {
    &::before {
      background: #1890ff !important;
    }
  }
}
.foot {
  width: 638px;
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999999;
  margin: 230px auto;
}
</style>
